<template>
  <section class="seasonal-special-sec">
    <div class="container">
      <div class="sec-title">
        <h2>Yacht Charter Seasonal Specials</h2>
        <p>
          Experience the ultimate in luxury and adventure with our yacht rental
          services.
        </p>
        <div class="sec-btns">
          <router-link to="/" class="btn btn-dark-blue"
            >Get Started</router-link
          >
          <router-link
            to="/listing/listing-details"
            class="btn btn-primary d-flex align-items-center"
            ><i class="bx bx-bar-chart me-2"></i>Learn More</router-link
          >
        </div>
      </div>
    </div>
  </section>
</template>
